export * from './stickyFooterVendor';
